export enum SocialMediaPackageOptions {
  SKIPPED = 'SKIPPED',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA_PREMIUM',
}

export interface SelectSocialMediaPackageProps {
  onSelectPackage: (selected: SocialMediaPackageOptions) => void;
  priceInEur: number;
  selectedPackage?: SocialMediaPackageOptions;
}
